import '.ai{position:relative;}.ssr-plugin'
import '.aj{padding-top:96px;}.ssr-plugin'
import '.ak{padding-right:96px;}.ssr-plugin'
import '.al{padding-bottom:96px;}.ssr-plugin'
import '.am{padding-left:96px;}.ssr-plugin'
import '.an{max-width:1280px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.aq{gap:40px;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.ar{pointer-events:none;}.ssr-plugin'
import '.as{justify-content:space-around;}.ssr-plugin'
import '.at{opacity:0.5;}.ssr-plugin'
import '.au{font-size:14px;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.av{margin-right:6px;}.ssr-plugin'
import '.aw{margin-left:6px;}.ssr-plugin'
import '.ax{margin-bottom:-3px;}.ssr-plugin'
import { Logo } from '../assets/svg/Logo.js'
import { useState } from 'react'
import { useLocation } from 'wouter'
import { styled } from 'inlines'
import { Icon } from '../assets/icons/index.js'
import { Button } from './Button.js'
import { colors } from '../utils/colors.js'
import { LogoHeartOnly } from '../assets/svg/LogoHeartOnly.js'
import { MOBILE, TABLET } from '../utils/breakpoints.js'
import { useLanguage } from '../hooks/useLanguage.js'
import {
  useVotingRegion,
  useVotingRegionName,
} from '../hooks/useVotingRegion.js'
import { MenuVotingRegion } from './MenuVotingRegion.js'
import { SelectLanguageModal } from './SelectLanguageModal.js'
import { SelectVotingRegionModal } from './SelectVotingRegionModal.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { MENU_IN_FROM_BOTTOM, MENU_IN_FROM_TOP } from '../utils/animations.js'
import { OnceLogo } from '../assets/svg/OnceLogo.js'
import { useDictionary } from '../hooks/useDictionary.js'

const LANG_MENU_HEIGHT = 320

export const Footer = ({ votes, hideCart, style }) => {
  const [, setLocation] = useLocation()

  const totalVotes = Object.values<number>(votes ?? {}).reduce(
    (a, b) => a + b,
    0,
  )

  const {
    votingGroupTitle,
    start,
    cart,
    legalGroupTitle,
    votingIntegrity,
    termsOfService,
    privacyPolicy,
    imprint,
  } = useDictionary()

  const [lang] = useLanguage()
  const [votingRegion] = useVotingRegion()
  const votingRegionName = useVotingRegionName(votingRegion?.code)

  const [openLangMenu, setOpenLangMenu] = useState(false)
  const [openLangSelectModal, setOpenLangSelectModal] = useState(false)
  const [openRegionModal, setOpenRegionModal] = useState(false)
  const [menuPos, setMenuPos] = useState({
    x: 0,
    y: 0,
    height: 0,
    parentHeight: 0,
    openBelow: false,
  })

  return (
    <styled.footer className="ai aj ak al am"
      id="footer-content"
      style={{
        background: `linear-gradient(0deg, ${colors.secondary} 0%, ${transparentColor(colors.secondary, 0)} 80%)`,
        [TABLET]: {
          paddingTop: '48px',
          paddingRight: '48px',
          paddingBottom: '48px',
          paddingLeft: '48px',
        },
        [MOBILE]: {
          paddingTop: '48px',
          paddingRight: '16px',
          paddingBottom: '48px',
          paddingLeft: '16px',
        },
        ...style,
      }}
    >
      <styled.div className="an m e ao ap aq"
        style={{
          [MOBILE]: {
            flexDirection: 'column',
          },
        }}
      >
        <div className="e f aq h"
        >
          <Logo height={48} width={145} onClick={() => setLocation('/')} />
          <Button
            ariaLabel="footer-menu"
            id="footer-select"
            variant="border"
            leadIcon={
              <Icon type="globeIcon" style={{ pointerEvents: 'none' }} />
            }
            trailIcon={
              <Icon type="chevronDownIcon" style={{ pointerEvents: 'none' }} />
            }
            onClick={(e) => {
              const target = e.currentTarget as HTMLElement
              const rect = target.getBoundingClientRect()
              const offsetParent = target.offsetParent as HTMLElement | null
              const spaceBelow = window.innerHeight - rect.bottom
              const spaceAbove = rect.top
              const openBelow =
                spaceBelow >= LANG_MENU_HEIGHT || spaceBelow > spaceAbove
              setMenuPos({
                x: target.offsetLeft,
                y: target.offsetTop,
                height: target.offsetHeight,
                parentHeight: offsetParent?.offsetHeight ?? 0,
                openBelow,
              })
              setOpenLangMenu(!openLangMenu)
            }}
            style={{
              textAlign: 'left',
              [MOBILE]: {
                width: '100%',
              },
            }}
          >
            <styled.span className="ar"
              style={{
                [MOBILE]: {
                  width: '100%',
                  textAlign: 'left',
                },
              }}
            >
              {votingRegionName} · {lang?.name}
            </styled.span>
          </Button>
          <MadeWidthLove
            style={{
              display: 'flex',
              [MOBILE]: {
                display: 'none',
              },
            }}
          />
        </div>

        <styled.div className="e h as"
          style={{
            [TABLET]: {
              flexDirection: 'column',
            },
            [MOBILE]: {
              gap: 24,
              marginTop: 40,
            },
            '& ul': {
              marginBlockStart: 16,
              listStyleType: 'none',
              paddingInlineStart: 0,
              fontSize: 18,
              lineHeight: '24px',
              letterSpacing: 0.18,
            },
            '& li': {
              marginBottom: 16,
            },
            '& a': {
              textDecoration: 'none',
              color: colors.white,
              '&:hover': {
                opacity: 0.75,
              },
            },
          }}
        >
          {/* // Nav 1 */}
          <styled.div style={{ [TABLET]: { marginBottom: 16 } }}>
            <label className="at au">
              {votingGroupTitle}
            </label>
            <ul>
              <styled.li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault()
                    setLocation('/')
                  }}
                >
                  {start}
                </a>
              </styled.li>
              {!hideCart && (
                <styled.li>
                  <a
                    href="/cart"
                    onClick={(e) => {
                      e.preventDefault()
                      setLocation('/cart')
                    }}
                  >
                    {cart} ({totalVotes})
                  </a>
                </styled.li>
              )}
            </ul>
          </styled.div>
          {/* // Nav 2 */}
          <styled.div>
            <label className="at au">
              {legalGroupTitle}
            </label>
            <styled.ul>
              <styled.li>
                <a
                  href="/voting-integrity"
                  onClick={(e) => {
                    e.preventDefault()
                    setLocation('/voting-integrity')
                  }}
                >
                  {votingIntegrity}
                </a>
              </styled.li>
              <styled.li>
                <a
                  href="/terms-of-service"
                  onClick={(e) => {
                    e.preventDefault()
                    setLocation('/terms-of-service')
                  }}
                >
                  {termsOfService}
                </a>
              </styled.li>
              <styled.li>
                <a
                  href="/privacy-policy"
                  onClick={(e) => {
                    e.preventDefault()
                    setLocation('/privacy-policy')
                  }}
                >
                  {privacyPolicy}
                </a>
              </styled.li>
              <styled.li>
                <a
                  href="/imprint"
                  onClick={(e) => {
                    e.preventDefault()
                    setLocation('/imprint')
                  }}
                >
                  {imprint}
                </a>
              </styled.li>
            </styled.ul>
          </styled.div>
        </styled.div>
      </styled.div>
      <MadeWidthLove
        style={{
          display: 'none',
          [MOBILE]: {
            marginTop: 40,
            display: 'flex',
          },
        }}
      />

      {openLangMenu && (
        <MenuVotingRegion
          setOpen={setOpenLangMenu}
          setOpenLangSelectModal={setOpenLangSelectModal}
          setOpenRegionModal={setOpenRegionModal}
          id="footer-select"
          triggerId="footer-select"
          animation={menuPos.openBelow ? MENU_IN_FROM_TOP : MENU_IN_FROM_BOTTOM}
          style={{
            ...(menuPos.openBelow
              ? { top: menuPos.y + menuPos.height + 8, bottom: 'unset' }
              : { top: 'unset', bottom: menuPos.parentHeight - menuPos.y + 8 }),
            left: lang.rtl ? null : menuPos.x,
            [MOBILE]: {
              left: '8px',
              right: '8px',
              width: 'auto',
            },
          }}
        />
      )}

      {openLangSelectModal && (
        <SelectLanguageModal setModal={setOpenLangSelectModal} />
      )}

      {openRegionModal && (
        <SelectVotingRegionModal setModal={setOpenRegionModal} />
      )}
    </styled.footer>
  )
}

const MadeWidthLove = ({ style }) => {
  const [lang] = useLanguage()
  return (
    <styled.p className="au w e"
      dir="ltr"
      style={{
        justifyContent: lang.rtl ? 'flex-end' : 'flex-start',
        ...style,
      }}
    >
      <span className="at av">
        Made with
      </span>
      <LogoHeartOnly />
      <styled.span className="at aw av"
        style={{
          '& a': {
            fontSize: 14,
          },
        }}
      >
        by
      </styled.span>
      <a className="ax"
        href="https://once.net"
        target="_blank"
      >
        <OnceLogo />
      </a>
    </styled.p>
  )
}
